import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --->>>>>>>>>>>>>>>   Fetch Service Provider List api call   <<<<<<<<<<<<<<---
const MAIL_SCHEDULE_LIST = ({ commit }, data) => {
  return ApiServices.getMailScheduleList(data)
    .then(response => {
      commit('getMailingList', response)
      console.log("getMailingList=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Fetch Service Provider List api call   <<<<<<<<<<<<<<---
const MAIL_STATUS = ({
  commit
}, data) => {
  return ApiServices.changeMailStatus(data)
    .then(response => {
      commit('getMailingList', response)
      console.log("getMailingList=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}
const MAIL_REPORT = ({
  commit
}, data) => {
  return ApiServices.getMailReport(data)
    .then(response => {
      commit('mailReportStatus', response)
      console.log("getMailingList=====", response)
    })
}


const CHECK_FAILED_MAILINGS = ({}, data) => {
  return ApiServices.checkFailedMailings(data)
    .then(response => response)
}

export default {
  MAIL_SCHEDULE_LIST,
  MAIL_STATUS,
  MAIL_REPORT,
  CHECK_FAILED_MAILINGS
}


// WEBPACK FOOTER //
// ./src/store/modules/mailing/actions.js